export function kioskLogout() {
    window?.siteKiosk?.logout();
}
